import React from 'react';

import styles from '../compensationCardStyles';

import CompensationInfo from 'buyside/components/presentation/CompensationIndexPage/CompensationCard/CompensationInfo/compensationInfo';
import FlagCompensationContainer from 'buyside/components/container/CompensationIndex/FlagCompensationContainer';

import SZLogoIcon from 'buyside/svgs/sz-logo.svg';

import { compensationAdminEditUrl } from 'buyside/util/urlHelper';

const CompensationCardBottom = ({ node, isAdmin }) => {
  const renderAdminLink = () => {
    if (isAdmin) {
      return (
        <span className={styles.actionEach}>
          <SZLogoIcon className={styles.actionIcon} />
          <a href={compensationAdminEditUrl(node.id)} className={styles.actionText}>
            Admin
          </a>
        </span>
      );
    }
  };

  return (
    <div className={styles.contentAreaBottom}>
      <CompensationInfo {...node} />
      <div className={styles.actionArea}>
        {renderAdminLink()}
        <FlagCompensationContainer id={node.id} />
      </div>
    </div>
  );
};

export default CompensationCardBottom;
